"use client"

import { useSnapshot } from "valtio"
import { AccountState } from "../../stores/accountStore"

export function useChainArch() {
  const { chainArch } = useSnapshot(AccountState)
  return chainArch
}
